module.exports = __webpack_public_path__ + "static/media/hero-image.865ef23d.png";